import { render, staticRenderFns } from "./ExploreCommunities.vue?vue&type=template&id=01965fb2&scoped=true&"
import script from "./ExploreCommunities.vue?vue&type=script&lang=js&"
export * from "./ExploreCommunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01965fb2",
  null
  
)

export default component.exports